module.exports = __webpack_public_path__ + "static/media/ccur.3d702603.png";